import { useCallback, useMemo, useState } from 'react';
import { format } from 'date-fns';
import { Notice, TargetType } from '@/features/notice/types/notice.types';

export interface NoticeFilter {
    startDate: string;
    endDate: string;
    targetType: TargetType | '';
}

export const useNoticeFilter = (allNotices: Notice[]) => {
    const [filter, setFilter] = useState<NoticeFilter>({
        startDate: '',
        endDate: '',
        targetType: '',
    });

    const handleFilterChange = useCallback((updates: Partial<NoticeFilter>) => {
        setFilter(prev => ({ ...prev, ...updates }));
    }, []);

    const handleReset = useCallback(() => {
        setFilter({ startDate: '', endDate: '', targetType: '' });
    }, []);

    const notices = useMemo(() => {
        const filtered = allNotices.filter(notice => {
            if (notice.startDate) {
                const noticeStartStr = format(notice.startDate, 'yyyy-MM-dd');
                if (filter.startDate && noticeStartStr < filter.startDate) return false;
                if (filter.endDate && noticeStartStr > filter.endDate) return false;
            }
            if (filter.targetType && notice.targetType !== filter.targetType) return false;
            return true;
        });

        return filtered.sort((a, b) => {
            const dateA = a.insDate ? new Date(a.insDate).getTime() : 0;
            const dateB = b.insDate ? new Date(b.insDate).getTime() : 0;
            return dateB - dateA;
        });
    }, [allNotices, filter]);

    return { notices, filter, handleFilterChange, handleReset };
};
